export default __webpack_public_path__ + "static/media/Deals2Home_app3.76561e7d.jpg";